/**
 * Nayda wordmark — the brand lockup.
 * The dot is the rare Marigold accent, hardcoded so consumers don't accidentally
 * recolor it. Size is controlled via Tailwind text classes on the wrapper.
 */
export function Wordmark({ className = '' }: { className?: string }) {
	return (
		<span className={`font-sans font-semibold tracking-tight text-ink ${className}`}>
			Nayda<span className="text-marigold">.</span>
		</span>
	)
}
